import {RefLinksContainer, RefLinksMobileContainer, useRefLinks} from '@features/pom'
import {useIsMobile} from '@hconnect/uikit'
import {PageTitle, PageContainer, CardBox} from '@hconnect/uikit/src/lib2'
import React from 'react'
import {useTranslation} from 'react-i18next'

export const ReferenceLinksPage: React.FC = () => {
  const {t} = useTranslation()
  const isMobile = useIsMobile()
  const {data: dataRefLinks = [], isLoading} = useRefLinks()

  return (
    <PageContainer>
      <PageTitle sx={{ml: 0}} data-test-id="page-title-refLinks">
        {t('referenceLinksPage.title')}
      </PageTitle>
      <CardBox>
        {isMobile ? (
          <RefLinksMobileContainer
            refLinksData={dataRefLinks}
            isLoading={isLoading}
          ></RefLinksMobileContainer>
        ) : (
          <RefLinksContainer refLinksData={dataRefLinks} isLoading={isLoading} />
        )}
      </CardBox>
    </PageContainer>
  )
}
